// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

import {MenuContext} from './menu_context';

import './menu_group.scss';

type Props = {
    divider?: React.ReactNode;
    children?: React.ReactNode;
}

export default class MenuGroup extends React.PureComponent<Props> {
    public static contextType = MenuContext;

    hideSubmenuItem = () => this.context.onCloseSubMenuItem();

    handleDividerClick = (e: React.MouseEvent): void => {
        e.preventDefault();
        e.stopPropagation();
    }

    public render() {
        const {children} = this.props;

        const divider = this.props.divider || (
            <li
                className='MenuGroup menu-divider'
                onClick={this.handleDividerClick}
                onMouseEnter={this.hideSubmenuItem}
            />
        );

        return (
            <React.Fragment>
                {divider}
                {children}
            </React.Fragment>
        );
    }
}
